export interface UnitDisplayNameInput {
  displayName: string;
  name: string;
}

export const getUnitDisplayName = ({
  unit,
}: {
  unit: UnitDisplayNameInput;
}): string => {
  return unit.displayName || unit.name;
};
